<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 100 100"
        stroke="currentColor"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="10"
            d="M45.459 77.819l44.795-44.794A7.668 7.668 0 1 0 79.409 22.18L40.037 61.553 20.591 42.107A7.668 7.668 0 1 0 9.746 52.952L34.614 77.82a7.647 7.647 0 0 0 5.422 2.246 7.653 7.653 0 0 0 5.423-2.247z"
        />
    </svg>
</template>

<script>
export default {
    name: "CheckIcon"
};
</script>
